export default __webpack_public_path__ + "static/media/bg-benefits.93a7c56e.png";